var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
            'active': _vm.searchType == _vm.state.searchType
        },attrs:{"type":"button"},on:{"click":_vm.changeType}},[_c('img',{attrs:{"src":_vm.badgeUrl,"alt":""}}),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }